import { useGridSlotComponentProps } from '@mui/x-data-grid';
import { Pagination, PaginationItem, PaginationRenderItemParams } from '@material-ui/lab';
import React from 'react';
import styles from './SGSPagination.module.scss';

type Props = {
    children: React.ReactNode;
};

const SGSPagination: React.FC<Props> = () => {
    const { state, apiRef } = useGridSlotComponentProps();

    return (
        state.pagination.pageCount > 1 && (
            <Pagination
                count={state.pagination.pageCount}
                defaultPage={state.pagination.page + 1}
                boundaryCount={3}
                siblingCount={2}
                shape="rounded"
                variant="outlined"
                onChange={(_event, value) => apiRef.current.setPage(value - 1)}
                classes={{ root: styles.root, ul: styles.list }}
                renderItem={(item: PaginationRenderItemParams) => (
                    <PaginationItem
                        {...item}
                        classes={{
                            root: styles.item,
                            page: styles[item.type],
                            ellipsis: styles.ellipsis,
                            selected: styles.selected,
                            icon: styles.icon,
                        }}
                    />
                )}
            />
        )
    );
};

export default SGSPagination;
